// ── v1.1 footer links: Privacy · Terms (LEGAL_PAGES_ENABLED) · Help (SUPPORT_LINK_ENABLED) ──
// Renders nothing when both flags are off, so pages are unchanged from r2b.
import { Link } from "react-router-dom";
import { T } from "../tokens";
import { useLaunchConfig } from "../lib/launch-config";

export function LegalLinks({ align = "center" }: { align?: "center" | "left" }) {
  const { flags, supportEmail } = useLaunchConfig();
  if (!flags.legalPages && !(flags.supportLink && supportEmail)) return null;
  const link = { color: T.t2, fontFamily: T.body, fontSize: "12px", textDecoration: "underline", textUnderlineOffset: "2px" } as const;
  return (
    <nav aria-label="Legal and help" data-testid="legal-links"
      style={{ display: "flex", gap: "14px", flexWrap: "wrap", justifyContent: align === "center" ? "center" : "flex-start", marginTop: "10px" }}>
      {flags.legalPages && <Link to="/privacy" style={link}>Privacy</Link>}
      {flags.legalPages && <Link to="/terms" style={link}>Terms</Link>}
      {flags.supportLink && supportEmail && (
        <a href={`mailto:${supportEmail}?subject=Calibre%20help%20%26%20feedback`} style={link}>Help &amp; feedback</a>
      )}
    </nav>
  );
}
